angular.module('graph').controller('ph-request', [
    '$scope', 'ph-core', 'ph-paging', 'ph-touch-service', '$rootScope', '$timeout',
    function ($scope, $core, $paging, $phtouch, $root, $timeout) {

        $scope.$paging = $paging.new();

        $scope.query = $core.$uri.$query.new({
            page: 0,
            let: 0
        });

        $scope.loader = -1;

        $scope.$requests = [];

        $scope.$invites = [];

        $scope.$friends = null;

        $scope.$requester = null;

        $scope.entry_id = 0;

        $scope.entry = null;

        $scope.$entry = function (name, id) {
            if (name) $scope.entry = name;
            if (id)   $scope.entry_id = id;

            $scope.$on('ph-root-request-update', function ($e, $entry, $entry_id) {
                if ($entry) $scope.entry = $entry;
                if ($entry_id) $scope.entry_id = $entry_id;

                $scope.init();
            });
        };

        function make(state) {
            if (state === 'entry') {
                var $entry = $scope.entry !== null ? $scope.entry + '/' : '';
                $entry += $scope.entry_id !== 0 ? $scope.entry_id + '/' : '';

                if ($scope.entry === 'group')
                    $entry += 'participant/';
                else if ($scope.entry in ['webinar', 'event'] === true)
                    $entry += 'participant/';

                return $entry;
            }
        }

        $scope.init = function ($entry, $entry_id) {
            if ($entry) $scope.entry = $entry;
            if ($entry_id) $scope.entry_id = $entry_id;

            $scope.$request.entry.requests();
        };

        $scope.invites = function ($id, $requester) {
            if ($id) $scope.entry_id = $id;
            if ($requester) $scope.$requester = $requester;

            $scope.$request.profile.invites();
        };

        $scope.$request = {
            "profile": {
                "invites": function () {
                    if ($scope.$paging.pages > -1 && $scope.$paging.pages === $scope.$paging.page)
                        return;

                    var page = $scope.query.get('page');

                    $scope.query.set(
                        'page', +(++page)
                    );

                    if ($scope.$requester !== null)
                        $scope.query.set(
                            'requester', $scope.$requester
                        );
console.log();
                    $core.get('/xhr/' + make('entry') + 'invites?' + $scope.query.str())
                        .then(function ($response) {
                            if ($response.data.state === 0) {
                                /**
                                 *
                                 */
                                $scope.$paging.pages = $response.data.pages;

                                /**
                                 *
                                 */
                                $scope.$paging.page = $response.data.page;

                                /**
                                 *
                                 */
                                $scope.$invites = $scope.$invites.concat(
                                    $response.data.data
                                );
                            }

                            $scope.loader = 0;
                        });
                },
                "accept": function (key, $invite) {
                    $core.post('/xhr/' + make('entry') + 'invite/' + $invite.requester + '/' + $invite.requester_id)
                        .then(function ($response) {
                            if ($response.data.state === 0) {
                                $scope.$invites.splice(key, 1);
                            }
                        });
                },
                "reject": function (key, $invite) {
                    $core.delete('/xhr/' + make('entry') + 'invite/' + $invite.requester + '/' + $invite.requester_id)
                        .then(function ($response) {
                            if ($response.data.state === 0) {
                                $scope.$invites.splice(key, 1);
                            }
                        });
                }
            },
            "entry": {
                "term": function () {
                    if ($scope.$friends !== null) {
                        $root.$broadcast('ph-modal-invite', $scope.$friends);
                        return;
                    }

                    $core.get('/xhr/' + make('entry') + 'friends')
                        .then(function ($response) {
                            if ($response.data.state === 0) {
                                /**
                                 *
                                 */
                                $scope.$paging.pages = $response.data.pages;

                                /**
                                 *
                                 */
                                $scope.$paging.page = $response.data.page;

                                /**
                                 *
                                 */
                                $scope.$friends = $response.data.data;

                                $scope.$on('ph-request-entry-invite', function ($event, key, $profile) {
                                    $scope.$request.entry.invite(key, $profile)
                                });

                                $root.$broadcast('ph-modal-invite', $scope.$friends);
                            }

                            $scope.loader = 0;
                        });
                },
                "requests": function () {
                    if ($scope.$paging.pages > -1 && $scope.$paging.pages === $scope.$paging.page)
                        return;

                    var page = $scope.query.get('page');

                    $scope.query.set(
                        'page', +(++page)
                    );

                    $core.get('/xhr/' + make('entry') + 'requests?' + $scope.query.str())
                        .then(function ($response) {
                            if ($response.data.state === 0) {
                                /**
                                 *
                                 */
                                $scope.$paging.pages = $response.data.pages;

                                /**
                                 *
                                 */
                                $scope.$paging.page = $response.data.page;

                                /**
                                 *
                                 */
                                $scope.$requests = $scope.$requests.concat(
                                    $response.data.data
                                );
                            }

                            $scope.loader = 0;
                        });
                },
                "request": function () {
                    $core.post('/xhr/' + make('entry') + 'requests')
                        .then(function ($response) {
                            if ($response.data.state === 0) {
                                //
                            }
                        });
                },
                "invite": function (key, $profile) {
                    $core.post('/xhr/' + make('entry') + 'invite/' + $profile.id)
                        .then(function ($response) {
                            if ($response.data.state === 0) {
                                $scope.$friends[key].status = 'pending';
                                $root.$broadcast('ph-modal-invite-done', key, $scope.$friends[key]);
                            }
                        });
                },
                "accept": function (key, $profile) {
                    $core.post('/xhr/' + make('entry') + 'request/' + $profile.id)
                        .then(function ($response) {
                            if ($response.data.state === 0) {
                                $scope.$requests.splice(key, 1);
                            }
                        });
                },
                "reject": function (key, $profile) {
                    $core.delete('/xhr/' + make('entry') + 'request/' + $profile.id)
                        .then(function ($response) {
                            if ($response.data.state === 0) {
                                $scope.$requests.splice(key, 1);
                            }
                        });
                }
            }

        };
    }
]);

angular.module('graph').controller('ph-read-request-tab', [
    '$scope', '$controller', '$rootScope', 'ph-touch-service',
    function ($scope, $controller, $root, $phtouch) {
        angular.extend(this, $controller('ph-request', {$scope: $scope}));

        var $module = 'ph-read-request-tab';

        $phtouch.$watch($scope, $module, function () {
            $phtouch.$touch($module, function () {
                $scope.init();
            });
        });
    }
]);